var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/shipping/pdp-ship-restriction.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n<h3 class=\"c-shipping-restriction__h3\">\n\n    ";
output += runtime.suppressValue((lineno = 3, colno = 6, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_ship-restriction-header"])), env.opts.autoescape);
output += "\n\n</h3>\n\n<p class=\"c-shipping-restriction__p\" data-qa-shipping-restriction>\n\n    ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "shipRestrictionString"), env.opts.autoescape);
output += "\n    \n    ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "logisticClassString"), env.opts.autoescape);
output += "\n\n</p>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/shipping/pdp-ship-restriction.j2"] , dependencies)